import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home.jsx';
import Adoption from './pages/Adoption/Adoption.jsx';
import PetDetailPage from './pages/PetDetailPage/PetDetailPage.jsx';
import AdoptionForm from './pages/AdoptionForm/AdoptionForm.jsx';
import DonatePage from './pages/Donate/DonatePage.jsx';
import AboutPage from './pages/About/AboutPage.jsx';
import Gallery from './pages/Gallery/Gallery.jsx';
import News from './pages/News/News.jsx';
import NewsDetail from './pages/News/NewsDetail.jsx';
import NewsCalendar from './pages/News/NewsCalendar.jsx';
import HappyEndings from './pages/Adoption/HappyEndings.jsx';
import HappyEndingDetail from './pages/Adoption/HappyEndingDetail.jsx';
import HappyEndingsEntry from './pages/Adoption/HappyEndingsEntry.jsx';
import PetEntry from './pages/Adoption/PetEntry.jsx';
import UpdateDog from './pages/Adoption/UpdateDog.jsx';
import SponsorPage from './pages/Donate/SponsorPage.jsx';
import Volunteer from './pages/Donate/Volunteer.jsx';
import Contact from './pages/Contact/Contact.jsx';
import NewsWoofAndPaint from './pages/News/NewsWoofAndPaint.jsx';
import NewsEntry from './pages/News/NewsEntry.jsx';
import FAQPage from './pages/FAQ/FAQPage.jsx';

const AppRoutes = ({ basePath = '/' }) => {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="about" element={<AboutPage />} />
      <Route path="adoption" element={<Adoption />} />
      <Route path="adoption-form" element={<AdoptionForm />} />
      <Route path="faq" element={<FAQPage />} />
      <Route path="adoption/faq" element={<FAQPage />} />
      <Route path="adoption/:petSlug" element={<PetDetailPage />} />
      <Route path="donate" element={<DonatePage />} />
      <Route path="sponsor" element={<SponsorPage />} />
      <Route path="volunteer/:page?" element={<Volunteer />} />
      <Route path="gallery" element={<Gallery />} />
      <Route path="news" element={<News />} />
      <Route path="news/:newsSlug" element={<NewsDetail />} />
      <Route path="news/calendar" element={<NewsCalendar />} />
      <Route path="happyendings/page/:page?" element={<HappyEndings />} />
      <Route path="happyendings/:happyEndingSlug" element={<HappyEndingDetail />} />
      <Route path="happyendings" element={<HappyEndings />} />
      <Route path="happyendingsentry" element={<HappyEndingsEntry />} />
      <Route path="petentry" element={<PetEntry />} />
      <Route path="updatepet" element={<UpdateDog />} />
      <Route path="contact" element={<Contact />} />
      <Route path="news/woofandpaint" element={<NewsWoofAndPaint />} />
      <Route path="newsentry" element={<NewsEntry />} />
      {/* Catch all - redirect to base path */}
      <Route path="*" element={<Navigate to={basePath} replace />} />
    </Routes>
  );
};

export default AppRoutes;
